import { forwardRef, useEffect, useRef, useState } from 'react';

const WA_INBOUND_URL =
  'https://inbound.habit.io/c1831fbf-90b8-4eef-8413-ae1800f99a8f';
const SMS_INBOUND_URL =
  'https://inbound.habit.io/1a958218-f360-46e8-8490-69cf82b2b667';
const WA_METHOD = '5af7448a-5082-4060-9e78-372e3294e604';
const SMS_METHOD = '5c5e52d3-061e-4906-aa7a-71780b2c3a77';
const POLL_INTERVAL = 2000;
const RESEND_COOLDOWN = 30;

async function triggerChannel(channel, { phone, name, brand, requesterRef }) {
  const url = channel === 'whatsapp' ? WA_INBOUND_URL : SMS_INBOUND_URL;
  const body =
    channel === 'whatsapp'
      ? { phone, method: WA_METHOD, name, brand, requester_ref: requesterRef }
      : { phone, method: SMS_METHOD, requester_ref: requesterRef };
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

async function pollStatus(statusUrl) {
  const res = await fetch(statusUrl);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

async function verifyPin(verificationUrl, code) {
  const res = await fetch(verificationUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  const data = await res.json();
  if (!res.ok)
    throw Object.assign(new Error(data.detail || 'Código inválido'), { data });
  return data;
}

const WhatsAppIcon = ({ size = 36, color = '#25D366' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const C = {
  navy: 'var(--color-secondary)',
  wa: '#25D366',
  muted: 'var(--color-grey500)',
  border: 'var(--color-grey300)',
};

const s = {
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '28px 24px 24px',
    position: 'relative',
  },
  closeBtn: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    lineHeight: 1,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--color-grey400)',
    padding: 0,
  },
  iconCircle: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    flexShrink: 0,
  },
  heading: {
    margin: '0 0 12px',
    fontFamily: 'var(--font-bold, sans-serif)',
    fontSize: '20px',
    color: C.navy,
    lineHeight: '1.3',
  },
  subtext: {
    margin: '0 0 8px',
    fontSize: '14px',
    color: C.muted,
    lineHeight: '1.5',
  },
  primaryBtn: {
    width: '100%',
    padding: '12px',
    border: 'none',
    borderRadius: 'var(--border-radius-button, 8px)',
    color: '#fff',
    fontSize: '15px',
    fontFamily: 'var(--font-bold, sans-serif)',
    cursor: 'pointer',
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  outlineBtn: {
    width: '100%',
    padding: '12px',
    border: `1px solid ${C.border}`,
    borderRadius: 'var(--border-radius-button, 8px)',
    background: '#fff',
    color: 'var(--color-grey600)',
    fontSize: '15px',
    fontFamily: 'var(--font-bold, sans-serif)',
    cursor: 'pointer',
    marginBottom: '4px',
  },
  linkBtn: {
    background: 'none',
    border: 'none',
    color: C.navy,
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    padding: '6px 8px',
  },
  waitingBox: {
    width: '100%',
    background: '#EBF8FF',
    border: '1px solid #BEE3F8',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
};

// ---------- Steps ----------

function ChooseChannel({ onWhatsApp, onSms, onClose, isLoading, error }) {
  return (
    <div style={s.body}>
      <button style={s.closeBtn} onClick={onClose} aria-label="Fechar">
        ×
      </button>
      <div style={{ ...s.iconCircle, background: `${C.wa}1A` }}>
        <WhatsAppIcon size={36} color={C.wa} />
      </div>
      <h2 style={s.heading}>Confirmar contacto</h2>
      <p style={s.subtext}>Só falta confirmar o seu número.</p>
      <p style={{ ...s.subtext, marginBottom: error ? '12px' : '24px' }}>
        Pode fazê-lo rapidamente por WhatsApp ou SMS.
      </p>
      {error && (
        <p style={{ ...s.subtext, color: '#E53E3E', marginBottom: '16px' }}>
          {error}
        </p>
      )}
      <button
        style={{
          ...s.primaryBtn,
          background: C.wa,
          opacity: isLoading ? 0.3 : 1,
        }}
        onClick={onWhatsApp}
        disabled={isLoading}
      >
        <WhatsAppIcon size={18} color="#fff" />
        Confirmar com WhatsApp
      </button>
      <button
        style={{ ...s.outlineBtn, opacity: isLoading ? 0.3 : 1 }}
        onClick={onSms}
        disabled={isLoading}
      >
        Receber código por SMS
      </button>
    </div>
  );
}

function WaitingPoll({ channel, phone, expiresAt, onBack, onExpire, onClose }) {
  const isWa = channel === 'whatsapp';

  const calcSecondsLeft = () =>
    expiresAt
      ? Math.max(0, Math.floor((new Date(expiresAt) - Date.now()) / 1000))
      : 0;

  const totalSecondsRef = useRef(calcSecondsLeft());
  const [secondsLeft, setSecondsLeft] = useState(calcSecondsLeft);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (calcSecondsLeft() <= 0) {
      setTimeout(() => onExpireRef.current?.(), 0);
      return;
    }
    const id = setInterval(() => {
      const remaining = calcSecondsLeft();
      setSecondsLeft(remaining);
      if (remaining <= 0) {
        clearInterval(id);
        setTimeout(() => onExpireRef.current?.(), 0);
      }
    }, 1000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const ss = String(secondsLeft % 60).padStart(2, '0');
  const radius = 26;
  const circumference = 2 * Math.PI * radius;
  const dashOffset =
    circumference * (1 - secondsLeft / Math.max(1, totalSecondsRef.current));

  return (
    <div style={s.body}>
      <button style={s.closeBtn} onClick={onClose} aria-label="Fechar">
        ×
      </button>
      <div
        style={{ ...s.iconCircle, background: isWa ? `${C.wa}1A` : '#EBF4FF' }}
      >
        {isWa ? (
          <WhatsAppIcon size={36} color={C.wa} />
        ) : (
          <span style={{ fontSize: '28px' }}>💬</span>
        )}
      </div>
      <h2 style={s.heading}>Confirmação enviada</h2>
      <p style={s.subtext}>
        {isWa
          ? 'Enviámos uma mensagem para o seu WhatsApp.'
          : 'Enviámos um SMS para o seu telemóvel.'}
      </p>
      <p
        style={{
          fontSize: '14px',
          fontFamily: 'var(--font-bold, sans-serif)',
          color: C.navy,
          marginBottom: '20px',
        }}
      >
        {phone}
      </p>
      <div style={s.waitingBox}>
        <p
          style={{
            margin: 0,
            color: '#1A365D',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '1.5',
          }}
        >
          {isWa
            ? 'Por favor responda à mensagem no WhatsApp para confirmar.'
            : 'Por favor confirme a receção do SMS para continuar.'}
        </p>
        <div
          style={{
            position: 'relative',
            width: '64px',
            height: '64px',
            color: C.navy,
          }}
        >
          <svg
            width="64"
            height="64"
            style={{ transform: 'rotate(-90deg)' }}
            viewBox="0 0 64 64"
          >
            <circle
              cx="32"
              cy="32"
              r={radius}
              fill="none"
              stroke="#dbeafe"
              strokeWidth="4"
            />
            <circle
              cx="32"
              cy="32"
              r={radius}
              fill="none"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={dashOffset}
              style={{ transition: 'stroke-dashoffset 1s linear' }}
            />
          </svg>
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: '600',
              color: 'currentColor',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {mm}:{ss}
          </div>
        </div>
      </div>
      <button style={s.linkBtn} onClick={onBack}>
        ← Voltar ao método de envio
      </button>
    </div>
  );
}

function OtpInput({ cells, onChange, hasError, autoFocus }) {
  const refs = useRef([]);
  const borderColor = hasError ? '#E53E3E' : C.border;

  const advance = (idx) => {
    if (idx < 6) setTimeout(() => refs.current[idx + 1]?.focus(), 0);
  };
  const handleChange = (idx, e) => {
    const raw = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!raw) return;
    const next = [...cells];
    next[idx] = raw[raw.length - 1];
    onChange(next);
    advance(idx);
  };
  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      if (cells[idx]) {
        const next = [...cells];
        next[idx] = '';
        onChange(next);
      } else if (idx > 0) {
        const next = [...cells];
        next[idx - 1] = '';
        onChange(next);
        setTimeout(() => refs.current[idx - 1]?.focus(), 0);
      }
    } else if (e.key === 'ArrowLeft' && idx > 0) refs.current[idx - 1]?.focus();
    else if (e.key === 'ArrowRight' && idx < 6) refs.current[idx + 1]?.focus();
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData('text')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');
    const next = Array(7).fill('');
    for (let i = 0; i < 7 && i < pasted.length; i++) next[i] = pasted[i];
    onChange(next);
    setTimeout(() => refs.current[Math.min(pasted.length, 6)]?.focus(), 0);
  };

  const cellStyle = {
    width: '28px',
    height: '32px',
    border: 'none',
    borderRadius: '6px',
    background: '#f0f2f5',
    textAlign: 'center',
    fontSize: '16px',
    fontFamily: 'var(--font-bold, sans-serif)',
    color: C.navy,
    caretColor: C.navy,
    outline: 'none',
    textTransform: 'uppercase',
    padding: 0,
    cursor: 'text',
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        border: `1.5px solid ${borderColor}`,
        borderRadius: '999px',
        padding: '6px 14px',
        background: '#fff',
        marginBottom: '8px',
      }}
      onFocus={(e) => {
        const el = e.target;
        setTimeout(() => el.select(), 0);
      }}
    >
      {[0, 1, 2].map((i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          type="text"
          inputMode="text"
          maxLength={2}
          value={cells[i]}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          autoFocus={autoFocus && i === 0}
          style={cellStyle}
        />
      ))}
      <span
        style={{
          fontSize: '16px',
          color: C.muted,
          userSelect: 'none',
          margin: '0 4px',
          lineHeight: '32px',
        }}
      >
        -
      </span>
      {[3, 4, 5, 6].map((i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          type="text"
          inputMode="text"
          maxLength={2}
          value={cells[i]}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          style={cellStyle}
        />
      ))}
    </div>
  );
}

function WaitingPin({
  phone,
  expiresAt,
  pinError,
  isLoading,
  onPinSubmit,
  onBack,
  onResend,
  onExpire,
  onClose,
}) {
  const calcSecondsLeft = () =>
    expiresAt
      ? Math.max(0, Math.floor((new Date(expiresAt) - Date.now()) / 1000))
      : 0;

  const calcResendCd = () =>
    resendCdStartRef.current
      ? Math.max(
          0,
          RESEND_COOLDOWN -
            Math.floor((Date.now() - resendCdStartRef.current) / 1000),
        )
      : 0;

  const [resendCdLeft, setResendCdLeft] = useState(0);
  const [cells, setCells] = useState(Array(7).fill(''));
  const resendCdStartRef = useRef(null);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (calcSecondsLeft() <= 0) {
      setTimeout(() => onExpireRef.current?.(), 0);
      return;
    }
    const id = setInterval(() => {
      setResendCdLeft(calcResendCd());
      if (calcSecondsLeft() <= 0) {
        clearInterval(id);
        setTimeout(() => onExpireRef.current?.(), 0);
      }
    }, 1000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleResendClick = async (e) => {
    e.stopPropagation();
    resendCdStartRef.current = Date.now();
    setResendCdLeft(RESEND_COOLDOWN);
    try {
      await onResend();
      setCells(Array(7).fill(''));
    } catch {
      resendCdStartRef.current = null;
      setResendCdLeft(0);
    }
  };

  const allFilled = cells.every((c) => c);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (allFilled)
      onPinSubmit(cells.slice(0, 3).join('') + '-' + cells.slice(3).join(''));
  };

  return (
    <div style={s.body}>
      <button style={s.closeBtn} onClick={onClose} aria-label="Fechar">
        ×
      </button>
      <div style={{ ...s.iconCircle, background: '#EBF4FF' }}>
        <span style={{ fontSize: '28px' }}>💬</span>
      </div>
      <h2 style={s.heading}>Código enviado por SMS</h2>
      <p style={s.subtext}>Enviámos um código para o seu telemóvel.</p>
      <p
        style={{
          fontSize: '14px',
          fontFamily: 'var(--font-bold, sans-serif)',
          color: C.navy,
          marginBottom: '20px',
        }}
      >
        {phone}
      </p>
      <form
        onSubmit={handleSubmit}
        style={{ width: '100%', marginBottom: '12px' }}
      >
        <OtpInput
          cells={cells}
          onChange={setCells}
          hasError={!!pinError}
          autoFocus
        />
        {pinError && (
          <p style={{ margin: '0 0 10px', fontSize: '13px', color: '#E53E3E' }}>
            {pinError}
          </p>
        )}
        <button
          type="submit"
          style={{
            ...s.primaryBtn,
            background: C.navy,
            opacity: isLoading || !allFilled ? 0.7 : 1,
            marginBottom: 0,
          }}
          disabled={isLoading || !allFilled}
        >
          {isLoading ? 'A verificar…' : 'Confirmar código'}
        </button>
      </form>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          width: '100%',
        }}
      >
        <button
          style={{
            ...s.outlineBtn,
            marginBottom: 0,
            opacity: resendCdLeft > 0 ? 0.5 : 1,
            cursor: resendCdLeft > 0 ? 'not-allowed' : 'pointer',
          }}
          disabled={resendCdLeft > 0}
          onClick={handleResendClick}
        >
          {resendCdLeft > 0
            ? `Reenviar SMS (${resendCdLeft}s)`
            : 'Reenviar SMS'}
        </button>
        <button style={s.linkBtn} onClick={onBack}>
          ← Voltar ao método de envio
        </button>
      </div>
    </div>
  );
}

function Confirmed({ onClose }) {
  return (
    <div style={s.body}>
      <div style={{ ...s.iconCircle, background: '#F0FFF4' }}>
        <span style={{ fontSize: '32px', color: '#38A169' }}>✓</span>
      </div>
      <h2 style={s.heading}>Contacto confirmado com sucesso!</h2>
      <p style={{ ...s.subtext, marginBottom: '24px' }}>
        A sua simulação vai continuar.
      </p>
      <button style={{ ...s.primaryBtn, background: C.navy }} onClick={onClose}>
        Continuar
      </button>
    </div>
  );
}

function Rejected({ onEdit, onRetry }) {
  return (
    <div style={s.body}>
      <div style={{ ...s.iconCircle, background: '#FFF5F5' }}>
        <span style={{ fontSize: '32px', color: '#E53E3E' }}>⚠</span>
      </div>
      <h2 style={s.heading}>Este contacto não foi confirmado.</h2>
      <p style={{ ...s.subtext, marginBottom: '24px' }}>
        Por favor verifique o número introduzido.
      </p>
      <button style={{ ...s.primaryBtn, background: C.navy }} onClick={onEdit}>
        Alterar contacto
      </button>
      <button style={s.outlineBtn} onClick={onRetry}>
        Tentar novamente
      </button>
    </div>
  );
}

function NotValidated({ phone, onResend, onEdit, onClose }) {
  return (
    <div style={s.body}>
      <button style={s.closeBtn} onClick={onClose} aria-label="Fechar">
        ×
      </button>
      <div style={{ ...s.iconCircle, background: '#FFFAF0' }}>
        <span style={{ fontSize: '28px', color: '#D69E2E' }}>!</span>
      </div>
      <h2 style={s.heading}>Número não validado</h2>
      <p style={s.subtext}>Não foi possível validar o contacto:</p>
      <p
        style={{
          fontFamily: 'var(--font-bold, sans-serif)',
          color: C.navy,
          marginBottom: '20px',
          fontSize: '16px',
        }}
      >
        {phone}
      </p>
      <p style={{ ...s.subtext, marginBottom: '24px' }}>
        Verifique se o número está correto ou tente reenviar a mensagem de
        confirmação.
      </p>
      <button
        style={{ ...s.primaryBtn, background: C.navy }}
        onClick={onResend}
      >
        ↻ Reenviar mensagem
      </button>
      <button style={s.outlineBtn} onClick={onEdit}>
        ✎ Editar número
      </button>
    </div>
  );
}

// ---------- State machine ----------

const ConfirmMobileDialog = forwardRef(
  ({ onConfirm, onEdit, phone, name, brand }, ref) => {
    const [step, setStep] = useState('choose-channel');
    const [channel, setChannel] = useState('whatsapp');
    const [session, setSession] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [triggerError, setTriggerError] = useState(null);
    const [pinError, setPinError] = useState(null);
    const requesterRef = useRef(crypto.randomUUID());

    const resetAll = () => {
      setSession(null);
      setIsLoading(false);
      setTriggerError(null);
      setPinError(null);
      setChannel('whatsapp');
      setStep('choose-channel');
    };

    const handleClose = () => {
      resetAll();
      ref.current?.close();
    };

    const handleEditPhone = () => {
      resetAll();
      ref.current?.close();
      onEdit?.();
    };

    const handleConfirmed = () => {
      resetAll();
      onConfirm();
    };

    const selectChannel = async (ch) => {
      if (!name || !brand) {
        setTriggerError(
          'Dados do condutor incompletos. Preencha o nome e a marca do veículo.',
        );
        return;
      }
      setIsLoading(true);
      setTriggerError(null);
      try {
        const data = await triggerChannel(ch, {
          phone,
          name,
          brand,
          requesterRef: requesterRef.current,
        });
        setSession({
          id: data.id,
          statusUrl: data.status_url,
          verificationUrl: data.verification_url,
          expiresAt: data.expires_at,
          attemptsRemaining: data.attempts_remaining,
        });
        setChannel(ch);
        setStep(ch === 'sms' ? 'waiting-pin' : 'waiting-poll');
      } catch {
        handleConfirmed();
      } finally {
        setIsLoading(false);
      }
    };

    const handleResend = async () => {
      const data = await triggerChannel('sms', {
        phone,
        name,
        brand,
        requesterRef: requesterRef.current,
      });
      setSession({
        id: data.id,
        statusUrl: data.status_url,
        verificationUrl: data.verification_url,
        expiresAt: data.expires_at,
        attemptsRemaining: data.attempts_remaining,
      });
      setPinError(null);
    };

    const handlePinSubmit = async (code) => {
      if (!session?.verificationUrl) {
        // backend didn't provide a verification endpoint — treat submission as confirmed
        setStep('confirmed');
        return;
      }
      setIsLoading(true);
      setPinError(null);
      try {
        await verifyPin(session.verificationUrl, code);
        setStep('confirmed');
      } catch (e) {
        if (!e.data) {
          // backend crashed or network failure — bypass verification
          handleConfirmed();
        } else {
          setPinError(e.message || 'Código inválido. Tente novamente.');
        }
      } finally {
        setIsLoading(false);
      }
    };

    // Poll status_url for WhatsApp and SMS flows that don't use a PIN code
    useEffect(() => {
      if (step !== 'waiting-poll' || !session?.statusUrl) return;
      const id = setInterval(async () => {
        try {
          const data = await pollStatus(session.statusUrl);
          if (data.status !== 'pending') {
            clearInterval(id);
            setStep(
              data.status === 'confirmed' ? 'confirmed' : 'not-validated',
            );
          }
        } catch {
          // ignore transient poll errors
        }
      }, POLL_INTERVAL);
      return () => clearInterval(id);
    }, [step, session?.statusUrl]);

    const renderStep = () => {
      switch (step) {
        case 'choose-channel':
          return (
            <ChooseChannel
              onWhatsApp={() => selectChannel('whatsapp')}
              onSms={() => selectChannel('sms')}
              onClose={handleClose}
              isLoading={isLoading}
              error={triggerError}
            />
          );
        case 'waiting-poll':
          return (
            <WaitingPoll
              key={session?.id}
              channel={channel}
              phone={phone}
              expiresAt={session?.expiresAt}
              onBack={() => setStep('choose-channel')}
              onExpire={() => setStep('not-validated')}
              onClose={handleClose}
            />
          );
        case 'waiting-pin':
          return (
            <WaitingPin
              key={session?.id}
              phone={phone}
              expiresAt={session?.expiresAt}
              pinError={pinError}
              isLoading={isLoading}
              onPinSubmit={handlePinSubmit}
              onBack={() => setStep('choose-channel')}
              onResend={handleResend}
              onExpire={() => setStep('not-validated')}
              onClose={handleClose}
            />
          );
        case 'confirmed':
          return <Confirmed onClose={handleConfirmed} />;
        case 'rejected':
          return (
            <Rejected
              onEdit={handleEditPhone}
              onRetry={() => setStep('choose-channel')}
            />
          );
        case 'not-validated':
          return (
            <NotValidated
              phone={phone}
              onResend={() => selectChannel(channel)}
              onEdit={handleEditPhone}
              onClose={handleClose}
            />
          );
        default:
          return null;
      }
    };

    return (
      <dialog ref={ref} style={dialogStyle}>
        {renderStep()}
      </dialog>
    );
  },
);

const dialogStyle = {
  border: 'none',
  borderRadius: '12px',
  padding: '0',
  width: '90%',
  maxWidth: '420px',
  boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
};

export default ConfirmMobileDialog;
